const condoSec2_Object = (payload) => {
  return {
    type: "condoSec2",
    payload,
  };
};

export default condoSec2_Object;
